import * as TemplateTypes from 'types/template.types';
import BaseScene from '../scenes/base';
import { defineStore } from 'pinia';
import { Capacitor } from '@capacitor/core';
import { fromLocalStorage, mergeIntoLocalStorage } from 'util/util';

interface SceneState {
    scene: BaseScene | null,
    exiting: boolean,
    transitionClass: string
}

interface AppState {
    gameId: number,
    baseUrl: string,
    isDev: boolean,
    reduceFlashing: boolean,
    isFirstRun: boolean,
    preloadProgress: number,
    sceneState: SceneState,
    platform: String,
    colorFactsSeen: string[]
}

interface GlobalStorePersistedState {
    reduceFlashing: boolean,
    isFirstRun: boolean
}

console.log(process.env.NODE_ENV);
const hydrateStore = () => {
    let persisted : GlobalStorePersistedState = fromLocalStorage('global-store', {
        reduceFlashing: false,
        isFirstRun: true
    })

    return {
        gameId: 0,
        baseUrl: process.env.NODE_ENV === 'development' ? 'https://localhost:8000' : 'https://apexultra.herokuapp.com',
        //theme: Themes[persisted.themeKey] ?? Themes.default,
        platform: Capacitor.getPlatform().toLowerCase(),
        isDev: process.env.NODE_ENV === 'development',
        preloadProgress: 0,
        reduceFlashing: persisted.reduceFlashing,
        isFirstRun: persisted.isFirstRun,
        colorFactsSeen: [],
        sceneState: {
            scene: null,
            exiting: true,
            transitionClass: ''
        }
    }
}

const useGlobalStore = defineStore({
    id: 'editor',
    state: () : AppState => hydrateStore(),
    actions: {
        persist(){
            mergeIntoLocalStorage<GlobalStorePersistedState>('global-store', { 
                reduceFlashing: this.reduceFlashing,
                isFirstRun: this.isFirstRun
            });
        },
        /**
         * Set "first run" status. When `isFirstRun` is `true`, ads are not shown. Currently this 
         * value is set to `false` in the game module after the first game is finished.
         * 
         * @param isFirstRun 
         */
        setIsFirstRun(isFirstRun: boolean){
            this.isFirstRun = isFirstRun;
            this.persist();
        },  
        setPreloadProgress(val: number){
            this.preloadProgress = val;
        },
        /**
         * Called from within phaser scene's to update current scene information. This should
         * not be called from Vue.
         */
        updateSceneState(state: SceneState){
            this.sceneState = state;
        },
        /**
         * Called from within Vue to change the current phaser scene. Note that a current 
         * scene must be active before this can be called.
         * 
         * @param key - The key of the existing phaser scene.
         */
        startScene(key: string){
            if (key === this.sceneState.scene?.sceneKey){ //If current scene, must call restart
                this.sceneState.scene?.scene.restart();
                return;
            }
            
            this.sceneState.scene?.exit(key);
        },
        setReduceFlashing(val: boolean){
            this.reduceFlashing = val;
            this.persist();
            //mergeIntoLocalStorage<GlobalStorePersistedState>('global-store', { reduceFlashing: this.reduceFlashing });
        }
    },
    getters: {
        activeSceneKey: state => state.sceneState.scene?.sceneKey
    }
})

export { useGlobalStore };